import { render } from "./BaseDecorationLine.vue?vue&type=template&id=48f0224c&scoped=true"
import script from "./BaseDecorationLine.vue?vue&type=script&lang=js"
export * from "./BaseDecorationLine.vue?vue&type=script&lang=js"

import "./BaseDecorationLine.vue?vue&type=style&index=0&id=48f0224c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f0224c"]])

export default __exports__